import { render } from "./ContactLinks.vue?vue&type=template&id=6c1937b3&scoped=true"
const script = {}

import "./ContactLinks.vue?vue&type=style&index=0&id=6c1937b3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c1937b3"]])

export default __exports__